import React from "react"
import {Card, Col} from "react-bootstrap";
import ReactApexChart from "react-apexcharts";
import {useTranslation} from "react-i18next";

const TopProducts = (props:any) => {
    const {products, productAmounts} = props;
    const {t} = useTranslation();

    const series = [
        {
            name: t('Dashboard.sales'),
            data: productAmounts,
        },
    ];
    const generateRandomColors = (count: number): string[] => {
        return Array.from({ length: count }, () =>
            "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0")
        );
    };

    const options = {
        chart: {
            type: "bar",
            height: 350,
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: true,
                columnWidth: "50%",
                distributed: true
            },
        },
        dataLabels: {
            enabled: true,
        },
        xaxis: {
            categories: products,
        },
        colors: generateRandomColors(productAmounts.length)
    };
    return (
        <React.Fragment>
            <Col xs={12}>
                <Card>
                    <Card.Body>
                        <Card.Title>
                            {t('Dashboard.top_products')}
                        </Card.Title>
                        <ReactApexChart options={options} series={series} type="bar" height={350} />
                    </Card.Body>
                </Card>

            </Col>
        </React.Fragment>
    )



}
export default TopProducts;